import React, { useState, useEffect } from 'react';
import '../styles/layout/LandingPage.scss';
import Carousel from 'react-material-ui-carousel';
import { Paper, Card } from '@mui/material';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';


const CarousalPage = () => {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,        
        waitForAnimate: false,
        autoplaySpeed: 4000,
        cssEase: "linear",
        autoplay: true,
        fade: true,
        beforeChange: (current, next) => {
            setOldSlide(current);
            setActiveSlide(next);
          },
          afterChange: current => setActiveSlide2(current).Card,
          
      };
      
      const [oldSlide, setOldSlide] = useState(0);
      const [activeSlide, setActiveSlide] = useState(0);
      const [activeSlide2, setActiveSlide2] = useState(0);
   
        return (            
        <Slider {...settings}>
                <div>
                <Card className='carouselConatiner' key={activeSlide} >
                    
                    <Paper className='innerItems'>
                        <div className='constantText'>
                            <h1 >{'Our'}</h1>
                            <h1>{'Expertise'}</h1>
                        </div>
                        <div className='roundContainer'>
                            <img alt="" src="/assets/landingPage/curve_pink.png" className='sm-img one'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img two'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img three'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img four'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img five'></img>
                        </div>
                    </Paper>
                    <Paper className='innerItems'>
                        <div className='constantText'>
                            <h1 >{'AI & Machine'}</h1>
                            <h1>{'Learning'}</h1>
                        </div>
                        <div className='contentItems'>
                            <p>Building intelligent systems to </p>
                            <p>automate and optimize processes.</p>
                            <Link to='/AIML' style={{ 
                                display: "inline-block",
                                width: "fit-content"
                            }}>
                            <button>
                                See how
                            </button>
                            </Link>
                        </div>

                    </Paper>

                    <Paper className='innerItems'>
                        <img alt="" src="/assets/landingPage/AIRight.webp" loading='lazy'></img>
                    </Paper>
                </Card> 
                </div>
            
                <div>
                <Card className='carouselConatiner' key={activeSlide}>
                    <Paper className='innerItems'>
                        <div className='constantText'>
                            <h1 >{'Our'}</h1>
                            <h1>{'Expertise'}</h1>
                        </div>
                        <div className='roundContainer'>
                            <img alt="" src="/assets/landingPage/Ellipse_76.png" className='sm-img one'></img>
                            <img alt="" src="/assets/landingPage/Ellipse_77.png" className='sm-img two'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img three'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img four'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img five'></img>
                        </div>
                    </Paper>

                    <Paper className='innerItems'>
                        <div className='constantText'>
                            <h1 >{'Data'}</h1>
                            <h1>{'Analytics'}</h1>
                        </div>
                        <div className='contentItems'>
                            <p>Converting raw data into meaningful  </p>
                            <p>insights for informed decision-making.</p>
                            <Link to='/DataAnalytics' style={{ 
                                display: "inline-block",
                                width: "fit-content"
                            }}>
                            <button>
                                See how
                            </button>
                            </Link>
                        </div>

                    </Paper>

                    <Paper className='innerItems'>
                        <img alt="" src="/assets/landingPage/DataRight.webp" loading='lazy'></img>
                    </Paper>
                </Card>
                </div>
            
                <div>
                <Card className='carouselConatiner' key={activeSlide}>
                    <Paper className='innerItems'>
                        <div className='constantText'>
                            <h1 >{'Our'}</h1>
                            <h1>{'Expertise'}</h1>
                        </div>
                        <div className='roundContainer'>
                            <img alt="" src="/assets/landingPage/Ellipse_76.png" className='sm-img one'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img two'></img>
                            <img alt="" src="/assets/landingPage/Ellipse_77.png" className='sm-img three'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img four'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img five'></img>
                        
                        </div>
                    </Paper>

                    <Paper className='innerItems'>
                        <div className='constantText'>
                            <h1 >{'Predictive'}</h1>
                            <h1>{'Modelling'}</h1>
                        </div>
                        <div className='contentItems'>
                            <p>Anticipating trends and behaviours to </p>
                            <p>empower proactive strategies.</p>
                            <Link to='/AI_PredictiveAnalysis' style={{ 
                                display: "inline-block",
                                width: "fit-content"
                            }}>
                            <button>
                                See how
                            </button>
                            </Link>
                        </div>

                    </Paper>

                    <Paper className='innerItems'>
                        <img alt="" src="/assets/landingPage/PredictiveRight.webp" loading='lazy'></img>
                    </Paper>
                </Card> 
                </div>
            
                <div>
                <Card className='carouselConatiner' key={activeSlide}>
                    <Paper className='innerItems'>
                        <div className='constantText'>
                            <h1 >{'Our'}</h1>
                            <h1>{'Expertise'}</h1>
                        </div>
                        <div className='roundContainer'>
                            <img alt="" src="/assets/landingPage/Ellipse_76.png" className='sm-img one'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img two'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img three'></img>
                            <img alt="" src="/assets/landingPage/Ellipse_77.png" className='sm-img four'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img five'></img>
                        </div>
                    </Paper>

                    <Paper className='innerItems'>
                        <div className='constantText'>
                            <h1 >{'Big Data'}</h1>
                            <h1>{'Management'}</h1>
                        </div>
                        <div className='contentItems'>
                            <p>Efficiently handling, storing, and</p>
                            <p>analyzing large-scale datasets.</p>
                            <Link to='/BigData' style={{ 
                                display: "inline-block",
                                width: "fit-content"
                            }}>
                            <button>
                                See how
                            </button>
                            </Link>
                        </div>

                    </Paper>

                    <Paper className='innerItems'>
                        <img alt="" src="/assets/landingPage/BigDataRight.webp" loading='lazy'></img>
                    </Paper>
                </Card>
                </div>
                
                    <div>
                    <Card className='carouselConatiner' key={activeSlide}>
                    <Paper className='innerItems'>
                        <div className='constantText'>
                            <h1 >{'Our'}</h1>
                            <h1>{'Expertise'}</h1>
                        </div>
                        <div className='roundContainer'>
                            <img alt="" src="/assets/landingPage/Ellipse_76.png" className='sm-img one'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img two'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img three'></img>
                            <img alt="" src="/assets/landingPage/curve_black.png" className='sm-img four'></img>
                            <img alt="" src="/assets/landingPage/Ellipse_77.png" className='sm-img five'></img>
                        </div>
                    </Paper>

                    <Paper className='innerItems'>
                        <div className='constantText'>
                            <h1 >{'Custom'}</h1>
                            <h1>{'Solutions'}</h1>
                        </div>
                        <div className='contentItems'>
                            <p>Tailoring analytics tools and platforms to </p>
                            <p>meet unique business needs.</p>
                            <Link to='/ProductEngineering' style={{ 
                                display: "inline-block",
                                width: "fit-content"
                            }}>
                            <button>
                                See how
                            </button>
                            </Link>
                        </div>

                    </Paper>

                    <Paper className='innerItems'>
                        <img alt="" src="/assets/landingPage/CustomRight.webp" loading='lazy'></img>
                    </Paper>
                </Card>
                    </div>
            
        </Slider>              
        )
};


export default CarousalPage;